import { type NotificationItem } from '@bluebrick/saas-ui'

export type LocalNotificationItem = NotificationItem & {
	sendToParent?: boolean
}

export const NewDataNotificationId = 'NEW_DATA'
